import { get } from 'lodash'

import { getFailType, getSuccessType } from 'common/api'
import { ACTION_TYPES } from './actions'

export const initialState = {
  products: [],
  isLoaded: false,
  isLoading: false,
  errors: null,
}

export default (state, action) => {
  switch (action.type) {
  case ACTION_TYPES.GET_PRODUCTS:
    return {
      ...state,
      isLoading: true,
      errors: null,
    }
  case getFailType(ACTION_TYPES.GET_PRODUCTS):
    return {
      ...state,
      products: [],
      isLoaded: true,
      isLoading: false,
      errors: 'Не удалось загрузить избранные товары',
    }
  case getSuccessType(ACTION_TYPES.GET_PRODUCTS):
    return {
      ...state,
      products: get(action, ['payload']),
      isLoaded: true,
      isLoading: false,
      errors: null,
    }
  default:
    return state
  }
}
